<div class="day-wrapper">
  <h3 class="day-title">{{ 'APPOINTMENT.CREATE-CONSULTATION.TIMEFRAME-FORM.WEEK-DAY.' + dayOfWeek() | translate }}</h3>
  @if ((consultationHourList$ | async).length <= 0 && createNewConsultationHour) {
    <div class="card blue-card no-shadow">
      <app-consultation-hour-form
        [prefillConsultationHours]="consultationHourList$"
        (onCancel)="createNewConsultationHour = false;"
        (onSave)="createNewConsultationHour = false;"
        [weekDay]="dayOfWeek()">
      </app-consultation-hour-form>
    </div>
  }
  @if ((consultationHourList$ | async).length > 0 && modifyConsultationHour) {
    <div class="card blue-card no-shadow">
      <app-consultation-hour-form
        [prefillConsultationHours]="consultationHourList$"
        (onCancel)="modifyConsultationHour = false;"
        (onSave)="modifyConsultationHour = false;"
        [weekDay]="dayOfWeek()">
      </app-consultation-hour-form>
    </div>
  }
  @if ((consultationHourList$ | async).length > 0 && !modifyConsultationHour) {
    <div class="card blue-card ch-summary no-shadow">
      <div class="no-modify-view" (click)="modifyConsultationHour = true;">
        <div class="modify-icon">
          <i class="fas fa-pen-alt"></i><i class="fal fa-ellipsis-h pull-down"></i>
        </div>
      </div>
      @for (consultationHour of (consultationHourList$ | async); track consultationHour) {
        <div class="consultation-hour-preview-line">
          <span class="time">
            {{ mapMomentToTimeString(consultationHour.startTime) }} - {{ mapMomentToTimeString(consultationHour.endTime) }}:
          </span>
          @for (chItem of consultationHour.consultationHourItems; track chItem) {
            @if (findProductById(chItem.productId); as product) {
              <span class="badge"
                ngbTooltip="{{ 'APPOINTMENT.CREATE-CONSULTATION.TIMEFRAME-FORM.TIMESPAN-TOO-SHORT-TOOLTIP' | translate }}"
                placement="bottom"
              [class.too-long-for-timespan]="isProductTooLongForTimespan(product, consultationHour.startTime, consultationHour.endTime)">{{ product.title }}</span>
            }
          }
        </div>
      }
    </div>
  }
  @if (!createNewConsultationHour && (consultationHourList$ | async).length <= 0) {
    <button class="btn btn-primary"
      (click)="createNewConsultationHour = true;">
      <i class="fal fa-plus"></i>
      {{ 'APPOINTMENT.CREATE-CONSULTATION.TIMEFRAME-FORM.ADD-TIMEFRAME' | translate }}
    </button>
  }
</div>
